import React, { useEffect, useState } from "react";

const BlueskyFeed = ({ handle, limit = 10 }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        // Replace this URL with the AT Protocol endpoint for the user's feed
        const response = await fetch(
          `https://bsky.social/xrpc/com.atproto.repo.listRecords?repo=${handle}&collection=app.bsky.feed.post&limit=${limit}`
        );
        const data = await response.json();
        setPosts(data.records || []);
      } catch (error) {
        console.error("Failed to fetch Bluesky feed:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeed();
  }, [handle, limit]);

  if (loading) return <p>Loading feed...</p>;
  if (!posts.length) return <p>No posts found.</p>;

  return (
    <div>
      {posts.map((post) => (
        <div key={post.cid} style={{ border: "1px solid #ccc", padding: "10px", margin: "10px 0" }}>
          <p><strong>@{handle}</strong></p>
          <p>{post.value?.text}</p>
          <small>{new Date(post.value?.createdAt).toLocaleString()}</small>
        </div>
      ))}
    </div>
  );
};

export default BlueskyFeed;